/*
    Плавное появление изображений по мере загрузки
*/

export class FadeInImage {
    constructor(img) {
        this.$img = $(img);
        this.init();
    }

    init() {
        this.$img.imagesLoaded({ background: true }, () => {
            this.$img.addClass('_loaded');
        });
    }
}


App.W.on('barba:afterEnter', () => {
    App.H.find('.js-barba-container .js-fadein-img').each(function() {
        new FadeInImage(this);
    });
});



// WEBPACK FOOTER //
// ./_src/js/modules/FadeInImage.js